import type { Reminder } from './velis-reminder'

const storageKey = 'velis.reminders'

interface ReminderHost {
  __velisReminders?: Reminder[]
}

function host() {
  return globalThis as typeof globalThis & ReminderHost
}

function isReminder(value: unknown): value is Reminder {
  if (typeof value !== 'object' || value === null)
    return false
  const record = value as Partial<Reminder>
  return typeof record.id === 'string'
    && typeof record.text === 'string'
    && typeof record.dueAt === 'string'
    && (record.status === 'open' || record.status === 'done')
}

function readStorage() {
  const storage = globalThis.localStorage
  if (!storage)
    return undefined
  try {
    const raw = storage.getItem(storageKey)
    if (!raw)
      return []
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter(isReminder) : []
  }
  catch {
    return []
  }
}

export function loadReminders() {
  const current = host()
  current.__velisReminders ??= readStorage() ?? []
  return [...current.__velisReminders]
}

export function replaceReminders(reminders: readonly Reminder[]) {
  const next = [...reminders]
  host().__velisReminders = next
  globalThis.localStorage?.setItem(storageKey, JSON.stringify(next))
}

export function resetReminders() {
  host().__velisReminders = []
  globalThis.localStorage?.removeItem(storageKey)
}
